<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{ this.categoryId == 1 ? "Project Management" : this.categoryId == 2 ? "Value Engineering" : "Learn" }}</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Category Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="about-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content" *ngIf="categoryId==1">
                    <h3>Project Management</h3>
                    <p>We provide a wide-range of project management applications from the initial project discovery
                        phase, budgeting, master planning, quality reviews and scheduling to procuring the right team
                        and executing the process through the close-out phase. A comprehensive list of add value
                        services is detailed below that we cater to your project needs. Here's an overview of the
                        typical project management processes in construction</p>
                    <ul class="about-list">
                        <li><i class="flaticon-tick"></i> Project Initiation</li>
                        <li><i class="flaticon-tick"></i>Project Planning</li>
                        <li><i class="flaticon-tick"></i> Resource Management</li>
                        <li><i class="flaticon-tick"></i> Time Management</li>
                        <li><i class="flaticon-tick"></i> Cost Management</li>
                        <li><i class="flaticon-tick"></i>Risk Management</li>
                        <li><i class="flaticon-tick"></i> Communication and Stakeholder Management</li>
                        <li><i class="flaticon-tick"></i> Quality Management</li>
                        <li><i class="flaticon-tick"></i> Procurement Management</li>
                        <li><i class="flaticon-tick"></i> Project Monitoring and Control</li>
                        <li><i class="flaticon-tick"></i> Project Closure</li>
                        <li><i class="flaticon-tick"></i> Project delivery</li>
                    </ul>
                </div>
                <div class="about-content" *ngIf="categoryId==2">
                    <h3>Value Engineering</h3>
                    <p>5When you partner with VE& More, you can expect both quality and value. Early in the design phase
                        of a construction project, the VE& More team works collaboratively with the client and architect
                        to apply value engineering techniques. Here's an overview of the typical processes involved in
                        value engineering in construction:</p>
                    <ul class="about-list">
                        <li><i class="flaticon-tick"></i> Information Gathering</li>
                        <li><i class="flaticon-tick"></i>Team Formation</li>
                        <li><i class="flaticon-tick"></i> Functional Analysis</li>
                        <li><i class="flaticon-tick"></i>Idea Generation</li>
                        <li><i class="flaticon-tick"></i> Evaluation and Selection</li>
                        <li><i class="flaticon-tick"></i>Development and Analysis</li>
                        <li><i class="flaticon-tick"></i> Recommendation and Implementation</li>
                        <li><i class="flaticon-tick"></i> Monitoring and Review</li>

                    </ul>
                </div>
                <div class="about-content" *ngIf="categoryId==3">
                    <h3>Learn</h3>
                    <p>Overall, learning value engineering and achieving VMA certification provide individuals with valuable knowledge, skills, and credentials. It enhances their professional capabilities, career prospects, and ability to deliver value-driven solutions</p>
                </div>
            </div>
        </div>
    </div>
</section>
